module.exports = __webpack_public_path__ + "static/montaz_barierek_law_kominiarskich-33de6d9488838a477a7addf6c5fa17d8.pdf";